import { useStudio } from '../store/studio-store';

export function Sidebar() {
  const _view = useStudio((s) => s.view);
  const setView = useStudio((s) => s.setView);
  const project = useStudio((s) => s.project);
  const currentFrame = useStudio((s) => s.currentFrame);
  const seekFrame = useStudio((s) => s.seekFrame);
  const toggleSafeAreas = useStudio((s) => s.toggleSafeAreas);
  const safeAreasVisible = useStudio((s) => s.safeAreasVisible);

  return (
    <aside className="sidebar">
      <div className="sidebar-section">
        <div className="sidebar-title">Project</div>
        <button type="button" className="sidebar-btn" onClick={() => setView('project')}>
          {project ? project.metadata.title : 'No project loaded'}
        </button>
        <button type="button" className="sidebar-btn" onClick={() => setView('assets')}>
          Assets ({project?.assets.length ?? 0})
        </button>
      </div>

      <div className="sidebar-section">
        <div className="sidebar-title">Views</div>
        <button type="button" className="sidebar-btn" onClick={() => setView('script')}>
          Script
        </button>
        <button type="button" className="sidebar-btn" onClick={() => setView('storyboard')}>
          Storyboard
        </button>
        <button type="button" className="sidebar-btn" onClick={() => setView('canvas')}>
          Canvas
        </button>
        <button type="button" className="sidebar-btn" onClick={() => setView('render')}>
          Render
        </button>
      </div>

      <div className="sidebar-section">
        <div className="sidebar-title">Display</div>
        <label className="sidebar-toggle">
          <input type="checkbox" checked={safeAreasVisible} onChange={toggleSafeAreas} />
          <span>Safe Areas</span>
        </label>
      </div>

      <div className="sidebar-section">
        <div className="sidebar-title">Playhead</div>
        <div className="frame-info">
          <span>Frame</span>
          <input
            type="number"
            min={0}
            max={project?.durationFrames ?? 0}
            value={currentFrame}
            onChange={(e) => seekFrame(Number(e.target.value))}
          />
          <span>/ {project?.durationFrames ?? 0}</span>
        </div>
      </div>
    </aside>
  );
}
